import { ChangeDetectorRef, Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbDatepickerConfig, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BussinessRegAppService } from 'app/service/business-reg-app/bussiness-reg-app.service';
import { TRCFundClasses } from 'app/shared/models/tRCFundClasses.model';
import { TRCUSPSBusAddr } from 'app/shared/models/trcUSPSBusAddr.model';
import { dateValidator, requiredValidator, requiredBusinessType, validateDate, requiredPayReceipt, validateNAICS,validateSICS,validateGgr } from 'app/shared/Validator/TRCApp.validator';
import { EappregFuzzyMatchComponent } from '../eappreg-fuzzy-match/eappreg-fuzzy-match.component';
import * as moment from 'moment';
import { FundClassGridArgs } from 'app/shared/models/fundClassGridArgs.model';
import { CustomAlertModalComponent } from 'app/shared/shared-component/custom-alert-modal/custom-alert-modal.component';
import { EappregL288MeasureComponent } from '../eappreg-L288-measure/eappreg-L288-measure.component';

@Component({
	selector: 'jhi-eappreg-app',
	templateUrl: './eappreg-app.component.html',
	styleUrls: ['./eappreg-app.component.scss']
})
export class EappregAppComponent implements OnInit {
	fc: TRCFundClasses[] = JSON.parse(sessionStorage.getItem("TRCFundClasses") ?? "[]").map((x: TRCFundClasses) => x.revenue_type)
//	headerDeclareStmt = "I declare, under penalty or perjury under the laws of the State of California that to the best of my knowledge the information provided in this application is true, correct and complete."
	fForm: any
	qfundClassGridList: TRCFundClasses[] = JSON.parse(sessionStorage.getItem("TRCFundClasses") ?? "");
	qfundClassGridListres: TRCFundClasses[] = [];
	qL288fundClassList: TRCFundClasses[] = [];
	trcFundClasses: TRCFundClasses[] = JSON.parse(sessionStorage.getItem("TRCFundClasses") ?? "");
	nonInitialFundClasses: TRCFundClasses[] = [];
	initialFundClasses: TRCFundClasses[] = [];
	L288InitialFundClasses: TRCFundClasses[] = [];
	textareaCount = 60
	errorMessages = {
		"busDesReqErr": "Please Enter Business Description.  It is a required field.",
		"busLegalNmErr": "Please Enter Legal Business Name. It is a required field.",
		"payReceiptErr": "Please Enter Global Gross Receipts Value. It is a required field.",
		"measureErr": "Please Enter Numeric value, it should not contain any special characters",
		"payDirectrequiredErr": "Please Enter Numeric value, it should not contain any special characters",

	}
	tRCAppForm = JSON.parse(sessionStorage.getItem("TRCAppForm") ?? "{}")
	unitTypeList = JSON.parse(sessionStorage.getItem("TRCUnitTypes") ?? "[]")
	// PO BOX not accepted for business address
	unitTypeExcludePO = JSON.parse(sessionStorage.getItem("TRCUnitTypes") ?? "[]").filter((el: any) => el.strUnit_Cd !== 'POBX')
	streetTypeList = JSON.parse(sessionStorage.getItem("TRCStreetTypes") ?? "[]")
	stateList = JSON.parse(sessionStorage.getItem("stateList") ?? "[]")
	miscTypes = JSON.parse(sessionStorage.getItem("TRCBusTypes") ?? "[]")
	exactMatch: any;
	tRCFuzzyMatches: any
	errorExist = false
	unitNumberErrorExist = false
	errorMessage = ""
	mASameAsBA = "N"
	showTaxPeriodGrid = false
	pastDate : any
	currentDate: any
	isLegalNameReadOnly = false;
	isDBANameReadOnly = false;
	mm : any
	dd :any
	yy : any
	mmm =12
	ddm =31
	yym : any
	curDate : any
	currDate: any
	issDisable: any
	inCityFlag = false;
	dumm : any
	getPageNum : any	
	parts : any;	
	year : any;	
	month : any;	
	day : any;	
	fromDateArr :any[] = [];	
	toDateArr :any[] = [];	
	yearString : any;	
	day1 : any;	
	date1 : any;
	//	INC0754669 - Enhancement - PFA EappReg - Adding GGR
	showGlobalGrossReceipts = false;
	measures: number[] = [];
	ggr: any;
	totalMsr : any;
	totMeasures : any;
	ngbModalOptions: NgbModalOptions = {
		backdrop: 'static',
		keyboard: false,
		size: 'lg',
		scrollable: false,
		centered: true
	};

	constructor(private fb: FormBuilder,
		private businessRegAppService: BussinessRegAppService,
		private el: ElementRef,
		private cdr: ChangeDetectorRef,
		private router: Router,
		private modalService: NgbModal,
		private cdRef: ChangeDetectorRef,
		config: NgbDatepickerConfig
	) {
		history.pushState(null, "", window.location.href);
		window.onpopstate = function() {
			history.go(1);
		};
		const TRCCurrGrpMetaName = sessionStorage.getItem("TRCCurrGrpMetaName");
		if(TRCCurrGrpMetaName==="FASTTRACKGRP"){
			sessionStorage.setItem("TRCBackPage", "FASTTRACK")}
			else{ sessionStorage.setItem("TRCBackPage", "N_Questions")}
		const currentpage = sessionStorage.getItem("TRCCurrentPage");
			if (currentpage === "eappreg_permit_main" || currentpage === "eappreg_fasttrack") {
			sessionStorage.setItem("TRCCurrentPage", "eappreg_app")
		} else if (currentpage === "eappreg_app") {
			// refreshed
		} else {
			// Didn't come from right program so proceed to error page.
			this.router.navigate(['error-page'])
			return;
		}

		this.businessRegAppService.getSystemDate().subscribe((res: string) => {
			this.currentDate = res.split(" ");
			const currDateArray = res.split(" ");
			const currentDate = currDateArray[0].split("/");
			config.minDate = { year: Number(currentDate[2]) - 7, month: Number(currentDate[0]), day: 1 };
			config.maxDate = { year: Number(currentDate[2]), month: 12, day: 31 };
			this.dd=Number(currentDate[1])
			this.mm=Number(currentDate[0])
			this.yy=Number(currentDate[2]) - 7
			this.yym=Number(currentDate[2])
			this.tRCAppForm.postMarkDt = new  Date(res);  
           sessionStorage.setItem("TRCAppForm", JSON.stringify(this.tRCAppForm)) 
		})

	}

	ngOnInit(): void {
		sessionStorage.setItem("totalMsr", "0");
		sessionStorage.removeItem("TRCUSPSBusAddr")
		this.fForm = this.fb.group({
			bus_desc: ["", [requiredValidator]],
			busid_legal_nm: ["", [requiredValidator]],
			busid_dba_nm: [""],
			busact_start_dt: ["", [dateValidator]],
			busact_bus_type: ["", [requiredBusinessType]],
			cbSameAddr: [""],
			busact_seller_permit: [""],
			busact_irs_activity_cd: ["", [requiredValidator,validateNAICS]],
			busact_irs_activity_cd2: ["", [validateNAICS]],
			pnaics: [""],
			snaics: [""],
			pnaics1: [""],
			snaics1: [""],			
			busact_irs_activity_cd3: [""],
			busact_irs_activity_cd4:[""],
			globalGrossReceipts: ["", [requiredValidator,validateGgr]],
			measures: this.fb.array([] as FormControl[]) // assuming measures is an array of form controls

		})
		this.checkGlobalGrossReceiptsCondition();

	}


//INC0754669 - Enhancement - PFA EappReg - Adding GGR
	checkGlobalGrossReceiptsCondition(): void {
        
        
        
        const dateParts = this.currentDate[0].split("/");

        const registrationMonth = Number(dateParts[0]); 
        const registrationYear = Number(dateParts[2]);  
        const businessStartDate = new Date(this.fForm.get('busact_start_dt').value);


        if ((registrationMonth === 1 || registrationMonth === 2) && businessStartDate.getFullYear() < registrationYear ) {
            this.showGlobalGrossReceipts = true;
        } else {
            this.showGlobalGrossReceipts = false;
			this.ggr='';
			this.fForm.controls.globalGrossReceipts.setErrors(null);
        }
    }

//INC0754669 - Enhancement - PFA EappReg - Adding GGR
	onGlobalGrossReceiptsChange(event: Event): void {
		const inputElement = event.target as HTMLInputElement;
		const value = inputElement.value;
		// eslint-disable-next-line no-console
		console.log('Global Gross Receipts changed:', this.totalMsr);
		this.ggr = value;
		
		// Implement any additional logic needed when globalGrossReceipts changes
	}

	selectedPrimaryNaicsCode(code: any):void {
		this.fForm.get("busact_irs_activity_cd").setValue(code.naic)
		this.fForm.get("busact_irs_activity_cd3").setValue(code.sic)
		
	}
	selectedSecondaryNaicsCode(code: any): void {
		this.fForm.get("busact_irs_activity_cd2").setValue(code.naic)
		this.fForm.get("busact_irs_activity_cd4").setValue(code.sic)
	}

	selectAddr(event: any): void {
		if (event.target.checked) {
			this.fForm.patchValue({
				"ma_str_nbr": this.fForm.get("ba_str_nbr")?.value,
				"ma_str_nbr_frac": this.fForm.get("ba_str_nbr_frac")?.value,
				"ma_str_dir_prefix": this.fForm.get("ba_str_dir_prefix")?.value,
				"ma_str_nm": this.fForm.get("ba_str_nm")?.value,
				"ma_str_dir_suffix": this.fForm.get("ba_str_dir_suffix")?.value,
				"ma_str_type": this.fForm.get("ba_str_type")?.value,
				"ma_unit_type": this.fForm.get("ba_unit_type")?.value,
				"ma_unit_nbr": this.fForm.get("ba_unit_nbr")?.value,
				"ma_city": this.fForm.get("ba_city")?.value,
				"ma_state": this.fForm.get("ba_state")?.value,
				"ma_zipcd": this.fForm.get("ba_zipcd")?.value,
				"ma_careof": this.fForm.get("ba_careof")?.value,
				"ma_commercial": this.fForm.get("ba_commercial")?.value

			});
			this.mASameAsBA = "Y"
		} else {
			this.fForm.patchValue({
				"ma_str_nbr": "",
				"ma_str_nbr_frac": "",
				"ma_str_dir_prefix": "",
				"ma_str_nm": "",
				"ma_str_dir_suffix": "",
				"ma_str_type": "",
				"ma_unit_type": "",
				"ma_unit_nbr": "",
				"ma_city": "",
				"ma_state": "CA",
				"ma_zipcd": "",
				"ma_careof": "",
				"ma_commercial": ""
			});
		}
	}
	formSubmit(): void {
		this.errorExist = false
		this.cdRef.detectChanges()
		if (this.fForm.valid) {
			this.errorMessage = ""
			
			const inputElements = document.getElementsByName("measure");

			for (let i = 0; i < inputElements.length; i++) {
				const id = 'measure_'.concat(i.toString());
				const measurefield = this.el.nativeElement.querySelector('[id="' + id + '"]');
				const measure = measurefield.value;
				if (measure.length > 0 && !this.isNumber(measure)) {
					measurefield.focus();
					const title = "Validation"
					const body = "Please correct the entered  measure value " + measure + ".It should not contain any special characters/decimal, It must be whole number only."
					const modalRef = this.modalService.open(CustomAlertModalComponent)
					modalRef.componentInstance.cModalTitle = title
					modalRef.componentInstance.cModalBody = body
					return;
				}
				
			}
			// INC0784244 GGR validation
			const ggrValue = this.fForm.get("globalGrossReceipts").value;
			if (ggrValue && !this.isNumber(ggrValue)) {
				const ggrField = this.el.nativeElement.querySelector('[formcontrolname="globalGrossReceipts"]');
				ggrField.focus();
				const title = "Validation";
				const body = "The Global Gross Receipts is invalid. Please enter the amount in numbers only, no characters or letters accepted in the Global Gross Receipt field.";
				const modalRef = this.modalService.open(CustomAlertModalComponent);
				modalRef.componentInstance.cModalTitle = title;
				modalRef.componentInstance.cModalBody = body;
				return;
			}
			if (this.issDisable===true) {
					const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="busact_start_dt"]');
					invalidControl.focus();
					return;
					
				}
			if (this.fForm.get("ma_unit_type").value?.trim() !== 'POBX') {
				if (this.fForm.get("ma_str_nbr").value?.trim().length === 0) {
					this.errorMessage = "Please Enter Mailing Address Street Number (must be numeric) or you can provide a PO Box Unit Type and Number.  A complete mailing address must be provided."
					this.errorExist = true
					this.scrollToError()
				}
				if (this.fForm.get("ma_str_nm").value?.trim().length === 0) {
					this.errorMessage = `${this.errorMessage} \n Please Enter Mailing Address Street Name or you can provide a PO Box Unit Type and Number.  A complete mailing address must be provided.`
					this.errorExist = true
					this.scrollToError()
				}
				if (this.errorExist) {
					return;
				}
			} else if (this.fForm.get("ma_unit_type").value?.trim() === 'POBX') {
				if (this.fForm.get("ma_unit_nbr").value?.trim().length === 0) {
					const unitNbr = this.el.nativeElement.querySelector('[name="ma_unit_nbr"]');
					unitNbr.focus();
					const title = "Validation"
					const body = "Unit Number is required for PO Box. "
					const modalRef = this.modalService.open(CustomAlertModalComponent)
					modalRef.componentInstance.cModalTitle = title
					modalRef.componentInstance.cModalBody = body
					return;
				}

			}
			
			/**  if (this.fForm.get("ba_str_nbr").value?.trim() === this.fForm.get("ba_str_nbr").value?.trim() &&
			   this.fForm.get("ba_str_nbr_frac").value?.trim() === this.fForm.get("ba_str_nbr_frac").value?.trim() &&
			   this.fForm.get("ba_str_dir_prefix").value?.trim() === this.fForm.get("ba_str_dir_prefix").value?.trim() &&
			   this.fForm.get("ba_str_nm").value?.trim() === this.fForm.get("ba_str_nm").value?.trim() &&
			   this.fForm.get("ba_str_dir_suffix").value?.trim() === this.fForm.get("ba_str_dir_suffix").value?.trim() &&
			   this.fForm.get("ba_str_type").value?.trim() === this.fForm.get("ba_str_type").value?.trim() &&
			   this.fForm.get("ba_unit_type").value?.trim() === this.fForm.get("ba_unit_type").value?.trim() &&
			   this.fForm.get("ba_unit_nbr").value?.trim() === this.fForm.get("ba_unit_nbr").value?.trim() &&
			   this.fForm.get("ba_city").value?.trim() === this.fForm.get("ba_city").value?.trim() &&
			   this.fForm.get("ba_state").value?.trim() === this.fForm.get("ba_state").value?.trim() &&
			   this.fForm.get("ba_zipcd").value?.trim() === this.fForm.get("ba_zipcd").value?.trim())
				{
			   this.mASameAsBA = "Y"
			 }*/
			this.tRCAppForm.bus_Desc = this.fForm.get("bus_desc").value?.trim()
			this.tRCAppForm.busid_Legal_Nm = this.fForm.get("busid_legal_nm").value?.trim()
			this.tRCAppForm.busid_Dba_Nm = this.fForm.get("busid_dba_nm").value?.trim()
			this.tRCAppForm.busact_Start_Dt = this.fForm.get("busact_start_dt").value?.trim()
			this.tRCAppForm.busact_Bus_Type = this.fForm.get("busact_bus_type").value?.trim()
			// business address data
			this.tRCAppForm.ba1_Str_Nbr = this.fForm.get("ba_str_nbr").value?.trim()
			this.tRCAppForm.ba1_Str_Nbr_Frac = this.fForm.get("ba_str_nbr_frac").value?.trim()
			this.tRCAppForm.ba1_Str_Dir_Prefix = this.fForm.get("ba_str_dir_prefix").value?.trim()
			this.tRCAppForm.ba1_Str_Nm = this.fForm.get("ba_str_nm").value?.trim()
			this.tRCAppForm.ba1_Str_Dir_Suffix = this.fForm.get("ba_str_dir_suffix").value?.trim()
			this.tRCAppForm.ba1_Str_Type = this.fForm.get("ba_str_type").value?.trim()
			this.tRCAppForm.ba2_Unit_Type = this.fForm.get("ba_unit_type").value?.trim()
			this.tRCAppForm.ba2_Unit_Nbr = this.fForm.get("ba_unit_nbr").value?.trim()
			this.tRCAppForm.ba3_City = this.fForm.get("ba_city").value?.trim()
			this.tRCAppForm.ba3_State = this.fForm.get("ba_state").value?.trim()
			this.tRCAppForm.ba3_ZipCd = this.fForm.get("ba_zipcd").value?.trim()
			this.tRCAppForm.ba2_CareOf = this.fForm.get("ba_careof").value?.trim()
			this.tRCAppForm.ba0_Commerical = this.fForm.get("ba_commercial").value?.trim()
			// mailing address data
			this.tRCAppForm.ma1_Str_Nbr = this.fForm.get("ma_str_nbr").value?.trim()
			this.tRCAppForm.ma1_Str_Nbr_Frac = this.fForm.get("ma_str_nbr_frac").value?.trim()
			this.tRCAppForm.ma1_Str_Dir_Prefix = this.fForm.get("ma_str_dir_prefix").value?.trim()
			this.tRCAppForm.ma1_Str_Nm = this.fForm.get("ma_str_nm").value?.trim()
			this.tRCAppForm.ma1_Str_Dir_Suffix = this.fForm.get("ma_str_dir_suffix").value?.trim()
			this.tRCAppForm.ma1_Str_Type = this.fForm.get("ma_str_type").value?.trim()
			this.tRCAppForm.mA2_Unit_Type = this.fForm.get("ma_unit_type").value?.trim()
			this.tRCAppForm.ma2_Unit_Nbr = this.fForm.get("ma_unit_nbr").value?.trim()
			this.tRCAppForm.ma3_City = this.fForm.get("ma_city").value?.trim()
			this.tRCAppForm.ma3_State = this.fForm.get("ma_state").value?.trim()
			this.tRCAppForm.ma3_ZipCd = this.fForm.get("ma_zipcd").value?.trim()
			this.tRCAppForm.ma2_CareOf = this.fForm.get("ma_careof").value?.trim()
			this.tRCAppForm.ma0_Commerical = this.fForm.get("ma_commercial").value?.trim()
			this.tRCAppForm.ma0_Sameas_Ba = this.mASameAsBA
			// cbSameAddr: [""],
			this.tRCAppForm.busact_Seller_Permit = this.fForm.get("busact_seller_permit").value?.trim()
			this.tRCAppForm.busact_Irs_Activity_Cd = this.fForm.get("busact_irs_activity_cd").value?.trim()
			this.tRCAppForm.busact_Irs_Activity_Cd2 = this.fForm.get("busact_irs_activity_cd2").value?.trim()
			this.tRCAppForm.busact_Irs_Activity_Cd3 = this.fForm.get("busact_irs_activity_cd3").value?.trim()
			this.tRCAppForm.busact_Irs_Activity_Cd4 = this.fForm.get("busact_irs_activity_cd4").value?.trim()

			this.tRCAppForm.buson_Name_First = this.fForm.get("buscon_first_name").value?.trim()
			this.tRCAppForm.buson_Name_Last = this.fForm.get("buscon_last_name").value?.trim()
			this.tRCAppForm.buson_Title = this.fForm.get("buscon_title").value?.trim()

			this.tRCAppForm.buson_Phone_Nbr = this.fForm.get("buscon_phAreaCd").value !== "" ? `(${String(this.fForm.get("buscon_phAreaCd").value)}) ${String(this.fForm.get("buscon_phExchNbr").value)}-${String(this.fForm.get("buscon_phTrnkNbr").value)}` : ""
			this.tRCAppForm.buson_Phone_Ext = this.fForm.get("buscon_phExtNbr").value?.trim()
			this.tRCAppForm.buson_Email = this.fForm.get("buscon_email_addr").value?.trim()
			this.tRCAppForm.buson_Web_Address = this.fForm.get("buscon_web_address").value?.trim()

			this.tRCAppForm.filer_Name_First = this.fForm.get("filedby_first_name").value?.trim()
			this.tRCAppForm.filer_Name_Last = this.fForm.get("filedby_last_name").value?.trim()
			this.tRCAppForm.filer_Title = this.fForm.get("filedby_title").value?.trim()
			this.tRCAppForm.filer_Phone_Nbr = this.fForm.get("filedby_phAreaCd").value !== "" ? `(${String(this.fForm.get("filedby_phAreaCd").value)}) ${String(this.fForm.get("filedby_phExchNbr").value)}-${String(this.fForm.get("filedby_phTrnkNbr").value)}` : ""
			this.tRCAppForm.filer_Phone_Ext = this.fForm.get("filedby_phExtNbr").value?.trim()
			this.tRCAppForm.filer_Email = this.fForm.get("filedby_email_addr").value?.trim()

			this.tRCAppForm.busid_idcheck = `${String(this.fForm.get("ba_str_nbr").value?.trim())} ${String(this.fForm.get("ba_str_nm").value?.trim())} ${String(this.fForm.get("ba_zipcd").value?.trim())}`.substr(0, 45)
			this.tRCAppForm.ggr = this.fForm.get("globalGrossReceipts").value?.trim()
			/*this.tRCAppForm.payReceipt = this.fForm.get("payReceipt").value !== "" ? this.fForm.get("payReceipt").value : ""*/
			sessionStorage.setItem("TRCAppForm", JSON.stringify(this.tRCAppForm));
			sessionStorage.setItem("TRCFundClasses", JSON.stringify(this.trcFundClasses))
			this.matchAddress({
				"stdAddress": "",
				"firmName": null,	
				"streetNumber": this.tRCAppForm.ba1_Str_Nbr,
				"streetPrefixDir": this.tRCAppForm.ba1_Str_Dir_Prefix,
				"streetName": this.tRCAppForm.ba1_Str_Nm,
				"streetNameSuffix": this.tRCAppForm.ba1_Str_Type,
				"streetSuffixDir": this.tRCAppForm.ba1_Str_Dir_Suffix,
				"unitType": this.tRCAppForm.ba2_Unit_Type,
				"unitNumber": this.tRCAppForm.ba2_Unit_Nbr,
				"city": this.tRCAppForm.ba3_City,
				"state": this.tRCAppForm.ba3_State,
				"zip": this.tRCAppForm.ba3_ZipCd
			})
		} else {
			this.fForm.markAllAsTouched();
			for (const key of Object.keys(this.fForm.controls)) {
				if (this.fForm.controls[key].invalid) {
					const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
					invalidControl.focus();
					break;
				}
			}
		}
	}
	matchAddress(data: any): void {

		this.businessRegAppService.matchAddressExact(data).subscribe((matchRes: any) => {

			const trcUSPSBusAddr: TRCUSPSBusAddr = new TRCUSPSBusAddr();
			trcUSPSBusAddr.streetNumber = matchRes.streetNumber
			trcUSPSBusAddr.streetPrefixDir = matchRes.streetPrefixDir
			trcUSPSBusAddr.streetName = matchRes.streetName
			trcUSPSBusAddr.streetSuffixDir = matchRes.streetSuffixDir
			trcUSPSBusAddr.streetNameSuffix = matchRes.streetNameSuffix
			trcUSPSBusAddr.unitType = matchRes.unitType
			trcUSPSBusAddr.unitNumber = matchRes.unitNumber
			trcUSPSBusAddr.city = matchRes.city
			trcUSPSBusAddr.state = matchRes.state
			trcUSPSBusAddr.zip = matchRes.zip
			trcUSPSBusAddr.zip4 = matchRes.zip4
			trcUSPSBusAddr.ruralRoute = matchRes.ruralRoute
			trcUSPSBusAddr.ruralBoxNumber = matchRes.ruralBoxNumber
			trcUSPSBusAddr.latitude = matchRes.latitude
			trcUSPSBusAddr.longitude = matchRes.longitude
			trcUSPSBusAddr.latax_dist = matchRes.latax_dist
			trcUSPSBusAddr.cd_no = matchRes.cd_no
			trcUSPSBusAddr.taps_cd = matchRes.taps_cd
			trcUSPSBusAddr.in_city = matchRes.in_city
			
			
			sessionStorage.setItem("TRCUSPSBusAddr", JSON.stringify(trcUSPSBusAddr))

			if (matchRes.resultStatus === "MultiMatch") {
				this.businessRegAppService.matchAddressFuzzy(data).subscribe((multiMatchRes: string) => {
					const multiMatchData = JSON.parse(multiMatchRes)


					if (multiMatchData.length !== 0) {
						const fuzzyMatchModal = this.modalService.open(EappregFuzzyMatchComponent, this.ngbModalOptions)
						fuzzyMatchModal.componentInstance.tRCFuzzyMatches = multiMatchData;
						fuzzyMatchModal.result.then((selectedAddrRes: any) => {
							if (selectedAddrRes.reason === 'PROCEED' && selectedAddrRes.selectedAddr !== undefined) {
								const addressArray = selectedAddrRes.selectedAddr.stdAddress.split(" ")
								const address = selectedAddrRes.selectedAddr
								this.matchAddress({
									"stdAddress": address.stdAddress,
									"firmName": address.firmName,
									"streetNumber": addressArray.length === 4 ? addressArray[0] : `${String(addressArray[0])} ${String(addressArray[1])}`,
									"streetPrefixDir": addressArray.length === 4 ? addressArray[1] : addressArray[2],
									"streetName": addressArray.length === 4 ? addressArray[2] : addressArray[3],
									"streetNameSuffix": addressArray.length === 4 ? addressArray[3] : addressArray[4],
									"streetSuffixDir": "",
									"unitType": "",
									"unitNumber": "",
									"city": address.city,
									"state": address.state,
									"zip": address.zip,
									"zip4": address.zip4
								})
							} else if (selectedAddrRes.reason === 'CANCEL') {
								fuzzyMatchModal.close()
							}
						})
					} else {
						this.navigateToEappregConfirm()
					}
				})
			} else if (matchRes.resultStatus === "Success") {

				trcUSPSBusAddr.streetNumber = matchRes.streetNumber
				trcUSPSBusAddr.streetPrefixDir = matchRes.streetPrefixDir
				trcUSPSBusAddr.streetName = matchRes.streetName
				trcUSPSBusAddr.streetSuffixDir = matchRes.streetSuffixDir
				trcUSPSBusAddr.streetNameSuffix = matchRes.streetNameSuffix
				trcUSPSBusAddr.unitType = matchRes.unitType
				trcUSPSBusAddr.unitNumber = matchRes.unitNumber
				trcUSPSBusAddr.city = matchRes.city
				trcUSPSBusAddr.state = matchRes.state
				trcUSPSBusAddr.zip = matchRes.zip
				trcUSPSBusAddr.zip4 = matchRes.zip4
				trcUSPSBusAddr.ruralRoute = matchRes.ruralRoute
				trcUSPSBusAddr.ruralBoxNumber = matchRes.ruralBoxNumber
				trcUSPSBusAddr.latitude = matchRes.latitude
				trcUSPSBusAddr.longitude = matchRes.longitude
				trcUSPSBusAddr.latax_dist = matchRes.latax_dist
				trcUSPSBusAddr.cd_no = matchRes.cd_no
				trcUSPSBusAddr.taps_cd = matchRes.taps_cd
				trcUSPSBusAddr.in_city = matchRes.in_city
				sessionStorage.setItem("", JSON.stringify(trcUSPSBusAddr))
				this.tRCAppForm.ba1_Str_Nbr = matchRes.streetNumber.split(" ")[0]
				this.tRCAppForm.ba1_Str_Nbr_Frac = matchRes.streetNumber.split(" ")[1]
				this.tRCAppForm.ba1_Str_Dir_Prefix = matchRes.streetPrefixDir
				this.tRCAppForm.ba1_Str_Nm = matchRes.streetName?.toUpperCase()
				this.tRCAppForm.ba1_Str_Dir_Suffix = matchRes.streetSuffixDir
				this.tRCAppForm.ba3_City = matchRes.city?.toUpperCase()
				this.tRCAppForm.ba3_State = matchRes.state?.toUpperCase()
				this.tRCAppForm.ba3_ZipCd = matchRes.zip
				this.tRCAppForm.busid_idcheck = `${String(matchRes.streetNumber.split(" ")[0])} ${String(matchRes.streetName?.toUpperCase())} ${String(matchRes.zip)}`.substr(0, 45)
				if (this.mASameAsBA === 'Y') {
					this.tRCAppForm.ma1_Str_Nbr = matchRes.streetNumber.split(" ")[0]
					this.tRCAppForm.ma1_Str_Nbr_Frac = matchRes.streetNumber.split(" ")[1] !== undefined ? matchRes.streetNumber.split(" ")[1] : ""
					this.tRCAppForm.ma1_Str_Dir_Prefix = matchRes.streetPrefixDir
					this.tRCAppForm.ma1_Str_Nm = matchRes.streetName?.toUpperCase()
					this.tRCAppForm.ma1_Str_Dir_Suffix = matchRes.streetSuffixDir
					this.tRCAppForm.ma3_City = matchRes.city?.toUpperCase()
					this.tRCAppForm.ma3_State = matchRes.state
					this.tRCAppForm.ma3_ZipCd = matchRes.zip
				}
				this.inCityFlag = trcUSPSBusAddr.in_city.toLowerCase() === 'true'?true:false;
				sessionStorage.setItem("TRCAppForm", JSON.stringify(this.tRCAppForm))
				this.navigateToEappregConfirm()
			} else if (matchRes.resultStatus === "Error") {
				this.navigateToEappregConfirm()
			}
		})
	}
	navigateToEappregConfirm(): void {
		 // ADD L288 IF L188 + IN-CITY
		if (this.trcFundClasses.find((el: TRCFundClasses) => "L188" === el.revenue_type) !== undefined && this.inCityFlag) {
              const revTypeStruct = new TRCFundClasses();
              revTypeStruct.revenue_type = "L288"
              this.trcFundClasses.push(revTypeStruct)
			this.qL288fundClassList.push(revTypeStruct);
			sessionStorage.setItem("TRCFundClasses", JSON.stringify(this.trcFundClasses));
			const dateData = this.fForm.get("busact_start_dt").value?.trim();
			const fundClassGridArgs = new FundClassGridArgs();
			fundClassGridArgs.fromDate = dateData;
			fundClassGridArgs.fundClasses = this.qL288fundClassList;
			this.businessRegAppService.getFundClassMeasureGrid(fundClassGridArgs).subscribe((gridRes: TRCFundClasses[]) => {
				this.qL288fundClassList = gridRes;
				if (this.qL288fundClassList.length > 1) {
					this.initialFundClasses = this.qL288fundClassList.filter((obj : any)=> obj.initialMeasureInd===1);
					/*This is to include initialFundClasses also in session*/
						for (let j = 0; j < this.initialFundClasses.length; j++) {
						if (!(this.initialFundClasses[j].currentTaxPeriod === true)) {
							//this.initialFundClasses[j].ggr=Number(sessionStorage.getItem("totalMsr"));
							this.initialFundClasses[j].ggr=this.ggr;
							this.trcFundClasses.push(this.initialFundClasses[j]);
						}
					}
					this.nonInitialFundClasses = this.qL288fundClassList.filter((obj : any)=> obj.initialMeasureInd===0 && !obj.currentTaxPeriod );
					this.L288InitialFundClasses = this.qL288fundClassList.filter((obj: any) => obj.initialMeasureInd === 1 && obj.currentTaxPeriod);
					for (let j = 0; j < this.nonInitialFundClasses.length; j++) {
						this.trcFundClasses.push(this.nonInitialFundClasses[j]);
					}
					this.qL288fundClassList = this.initialFundClasses;
					const l288MeasureModal = this.modalService.open(EappregL288MeasureComponent, this.ngbModalOptions)
					//INC0754669 - Enhancement - PFA EappReg - Adding GGR (Form control for L288 fund class)
						l288MeasureModal.componentInstance.fForm = this.fForm;
						l288MeasureModal.componentInstance.trcFundClass = this.qL288fundClassList;
						//INC0754669 - Enhancement - PFA EappReg - Adding GGR
						for (let j = 0; j < this.L288InitialFundClasses.length; j++) {
					const str = this.L288InitialFundClasses[j].taxPeriod;
					const lastLetter = str[str.length - 1];
					if (lastLetter === 'A' && this.L288InitialFundClasses[j].currentTaxPeriod ){
					const fundclIndex = this.trcFundClasses.findIndex(obj => obj.revenue_type === this.L288InitialFundClasses[j].revenue_type && obj.taxPeriod === '')
					//this.trcFundClasses[fundclIndex].ggr=Number(sessionStorage.getItem("totalMsr"));
					this.trcFundClasses[fundclIndex].ggr=this.ggr;
				}
			}
					for (let j = 0; j < this.qfundClassGridListres.length; j++) {
					const str = this.qfundClassGridListres[j].taxPeriod;
					const lastLetter = str[str.length - 1];
					if (lastLetter === 'A' && this.qfundClassGridListres[j].currentTaxPeriod ){
					const fundclIndex = this.trcFundClasses.findIndex(obj => obj.revenue_type === this.qfundClassGridListres[j].revenue_type && obj.taxPeriod === '')
					//this.trcFundClasses[fundclIndex].ggr=Number(sessionStorage.getItem("totalMsr"));
					this.trcFundClasses[fundclIndex].ggr=this.ggr;
				}
			}
						l288MeasureModal.result.then((response: any) => {
							 if (response.reason === 'OK') {
								l288MeasureModal.close()
				//INC0754669 - Enhancement - PFA EappReg - Adding GGR
				for (const key of Object.keys(this.fForm.controls)) {
				if (this.fForm.controls[key].invalid) {
					const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
					invalidControl.focus();
					this.router.navigate(['/eappreg_app'])
					this.trcFundClasses = this.trcFundClasses.filter(fundClass => fundClass.revenue_type !== 'L288');
					sessionStorage.setItem("TRCFundClasses", JSON.stringify(this.trcFundClasses));
					this.qL288fundClassList = [];
					return;
				}
				}
								this.router.navigate(['/eappreg_confirm'])
							}
						})
						sessionStorage.setItem("TRCFundClasses", JSON.stringify(this.trcFundClasses));
				} else{
					this.router.navigate(['/eappreg_confirm'])
				}
			});

            }else {
			for (let j = 0; j < this.qfundClassGridListres.length; j++) {
					const str = this.qfundClassGridListres[j].taxPeriod;
					const lastLetter = str[str.length - 1];
					if (lastLetter === 'A' && this.qfundClassGridListres[j].currentTaxPeriod ){
					const fundclIndex = this.trcFundClasses.findIndex(obj => obj.revenue_type === this.qfundClassGridListres[j].revenue_type && obj.taxPeriod === '')
					//this.trcFundClasses[fundclIndex].ggr=Number(sessionStorage.getItem("totalMsr"));
					this.trcFundClasses[fundclIndex].ggr=this.ggr;
				}
			}
			sessionStorage.setItem("TRCFundClasses", JSON.stringify(this.trcFundClasses));
			this.router.navigate(['/eappreg_confirm'])
		}

	}
	back(): void {
// go back
		const TRCCurrGrpMetaName = sessionStorage.getItem("TRCCurrGrpMetaName");
		if(TRCCurrGrpMetaName === "FASTTRACKGRP" ){
			this.router.navigate(['/eappreg_fasttrack'])
			}
		else{
			this.router.navigate(['/eappreg_questionnaire'])
		} 
	}

	convertToUpperCase(name: string): void {
		this.fForm.get(name)?.setValue(this.fForm.get(name)?.value.toUpperCase())
	}

	ngAfterViewInit(): void {
		const inputElem: any = document.getElementById("eappregForm")?.getElementsByTagName("input");
		const textareaElem: any = document.getElementById("eappregForm")?.getElementsByTagName("textarea");
		for (let i = 0; i < inputElem.length; i++) {
			if ((inputElem[i].type === "text" || textareaElem[0].type === "textarea") &&
				(inputElem[i].name !== "busact_start_dt") &&
				(inputElem[i].name !== "filedby_email_addr") &&
				(inputElem[i].name !== "buscon_email_addr") &&
				(inputElem[i].name !== "buscon_web_address")
			) {
				(<HTMLElement>inputElem[i]).addEventListener('change', () => {
					this.convertToUpperCase(inputElem[i].name)
				})
			}
		}



		this.fForm.get("bus_desc")?.setValue(this.tRCAppForm.bus_Desc)
		if (sessionStorage.getItem("LegalName") !== "") {
			this.fForm.get("busid_legal_nm")?.setValue(sessionStorage.getItem("LegalName"));
			this.isLegalNameReadOnly = true;
		}
		else {
			this.fForm.get("busid_legal_nm")?.setValue(this.tRCAppForm.busid_Legal_Nm)
		}

		if (sessionStorage.getItem("DBAName") !== "") {
			this.fForm.get("busid_dba_nm")?.setValue(sessionStorage.getItem("DBAName"));
			this.isDBANameReadOnly = true;
		}
		else {
			this.fForm.get("busid_dba_nm")?.setValue(this.tRCAppForm.busid_Dba_Nm)
		}
		this.fForm.get("busact_start_dt")?.setValue(this.tRCAppForm.busact_Start_Dt)
		this.fForm.get("busact_bus_type")?.setValue(this.tRCAppForm.busact_Bus_Type)
		// business address data
		this.fForm.get("ba_str_nbr")?.setValue(this.tRCAppForm.ba1_Str_Nbr)
		this.fForm.get("ba_str_nbr_frac")?.setValue(this.tRCAppForm.ba1_Str_Nbr_Frac)
		this.fForm.get("ba_str_dir_prefix")?.setValue(this.tRCAppForm.ba1_Str_Dir_Prefix)
		this.fForm.get("ba_str_nm")?.setValue(this.tRCAppForm.ba1_Str_Nm)
		this.fForm.get("ba_str_dir_suffix")?.setValue(this.tRCAppForm.ba1_Str_Dir_Suffix)
		this.fForm.get("ba_str_type")?.setValue(this.tRCAppForm.ba1_Str_Type)
		this.fForm.get("ba_unit_type")?.setValue(this.tRCAppForm.ba2_Unit_Type)
		this.fForm.get("ba_unit_nbr")?.setValue(this.tRCAppForm.ba2_Unit_Nbr)
		this.fForm.get("ba_city")?.setValue(this.tRCAppForm.ba3_City)
		this.fForm.get("ba_state")?.setValue(this.tRCAppForm.ba3_State ? this.tRCAppForm.ba3_State : "CA")
		this.fForm.get("ba_zipcd")?.setValue(this.tRCAppForm.ba3_ZipCd)
		this.fForm.get("ba_careof")?.setValue(this.tRCAppForm.ba2_CareOf)
		this.fForm.get("ba_commercial")?.setValue(this.tRCAppForm.ba0_Commerical)
		// mailing address data
		this.fForm.get("ma_str_nbr")?.setValue(this.tRCAppForm.ma1_Str_Nbr)
		this.fForm.get("ma_str_nbr_frac")?.setValue(this.tRCAppForm.ma1_Str_Nbr_Frac)
		this.fForm.get("ma_str_dir_prefix")?.setValue(this.tRCAppForm.ma1_Str_Dir_Prefix)
		this.fForm.get("ma_str_nm")?.setValue(this.tRCAppForm.ma1_Str_Nm)
		this.fForm.get("ma_str_dir_suffix")?.setValue(this.tRCAppForm.ma1_Str_Dir_Suffix)
		this.fForm.get("ma_str_type")?.setValue(this.tRCAppForm.ma1_Str_Type)
		this.fForm.get("ma_unit_type")?.setValue(this.tRCAppForm.mA2_Unit_Type)
		this.fForm.get("ma_unit_nbr")?.setValue(this.tRCAppForm.ma2_Unit_Nbr)
		this.fForm.get("ma_city")?.setValue(this.tRCAppForm.ma3_City)
		this.fForm.get("ma_state")?.setValue(this.tRCAppForm.ma3_State ? this.tRCAppForm.ma3_State : "CA")
		this.fForm.get("ma_zipcd")?.setValue(this.tRCAppForm.ma3_ZipCd)
		this.fForm.get("ma_careof")?.setValue(this.tRCAppForm.ma2_CareOf)
		this.fForm.get("ma_commercial")?.setValue(this.tRCAppForm.ma0_Commerical)
		this.fForm.get("cbSameAddr").setValue(this.tRCAppForm.ma0_Sameas_Ba === 'Y' ? true : false)

		this.fForm.get("busact_seller_permit")?.setValue(this.tRCAppForm.busact_Seller_Permit)
		this.fForm.get("busact_irs_activity_cd")?.setValue(this.tRCAppForm.busact_Irs_Activity_Cd)
		this.fForm.get("busact_irs_activity_cd2")?.setValue(this.tRCAppForm.busact_Irs_Activity_Cd2)
		this.fForm.get("busact_irs_activity_cd3")?.setValue(this.tRCAppForm.busact_Irs_Activity_Cd3)
		this.fForm.get("busact_irs_activity_cd4")?.setValue(this.tRCAppForm.busact_Irs_Activity_Cd4)

		this.fForm.get("buscon_first_name")?.setValue(this.tRCAppForm.buson_Name_First)
		this.fForm.get("buscon_last_name")?.setValue(this.tRCAppForm.buson_Name_Last)
		this.fForm.get("buscon_title")?.setValue(this.tRCAppForm.buson_Title)
		const buscon_phone_nbr = this.tRCAppForm.buson_Phone_Nbr
		if (buscon_phone_nbr !== "") {		
			this.fForm.get("buscon_phAreaCd")?.setValue(buscon_phone_nbr.substr(1, 3))
			this.fForm.get("buscon_phExchNbr")?.setValue(buscon_phone_nbr.substr(6, 3))
			this.fForm.get("buscon_phTrnkNbr")?.setValue(buscon_phone_nbr.substr(10, 4))
		}

		this.fForm.get("buscon_phExtNbr")?.setValue(this.tRCAppForm.buson_Phone_Ext)
		this.fForm.get("buscon_email_addr")?.setValue(this.tRCAppForm.buson_Email)
		this.fForm.get("buscon_web_address")?.setValue(this.tRCAppForm.buson_Web_Address)

		this.fForm.get("filedby_first_name")?.setValue(this.tRCAppForm.filer_Name_First)
		this.fForm.get("filedby_last_name")?.setValue(this.tRCAppForm.filer_Name_Last)
		this.fForm.get("filedby_title")?.setValue(this.tRCAppForm.filer_Title)
		const filer_phone_nbr = this.tRCAppForm.filer_Phone_Nbr
		if (filer_phone_nbr !== "") {
			this.fForm.get("filedby_phAreaCd")?.setValue(filer_phone_nbr.substr(1, 3))
			this.fForm.get("filedby_phExchNbr")?.setValue(filer_phone_nbr.substr(6, 3))
			this.fForm.get("filedby_phTrnkNbr")?.setValue(filer_phone_nbr.substr(10, 4))
		}
		this.fForm.get("filedby_phExtNbr")?.setValue(this.tRCAppForm.filer_Phone_Ext)
		this.fForm.get("filedby_email_addr")?.setValue(this.tRCAppForm.filer_Email)
		this.fForm.get("payReceipt")?.setValue(this.tRCAppForm.payReceipt)
		this.fForm.get("globalGrossReceipts")?.setValue(this.tRCAppForm.ggr)
		this.cdr.detectChanges()

	}

	scrollToError(): void {
		const elementPosition = Number(document.getElementById('alertRef')?.offsetTop);
		
		
		window.scrollTo({
			top: elementPosition - 40 ,
			behavior: "smooth"
		});
	}

	isDisabled(popover: any): any {
		const dateData = this.fForm.get("busact_start_dt")?.value;
		//if valid date check for condition - Business Start year < current year
		if (validateDate(dateData) === false) {
			if (dateData.split("/")[2] < moment().year()) {
				popover.open();
			}
		}
	}

	loadTaxperiodGrid(): any {
		this.dateValid();
		const dateData = this.fForm.get("busact_start_dt").value?.trim();
		this.qfundClassGridListres = [];
		if (validateDate(dateData) === false) {
			if (new Date(dateData) < new Date(this.currentDate[0])) {
				this.pastDate = true;
				this.tRCAppForm.pastDate = '0';
				sessionStorage.setItem("TRCAppForm", JSON.stringify(this.tRCAppForm)) 
			} else {
				this.pastDate = false;
				/*this.fForm.controls['payReceipt'].setErrors(null);*/
			}
			const fundClassGridArgs = new FundClassGridArgs();
			fundClassGridArgs.fromDate = dateData;
			fundClassGridArgs.fundClasses = this.qfundClassGridList;
			this.businessRegAppService.getFundClassMeasureGrid(fundClassGridArgs).subscribe((gridRes: TRCFundClasses[]) => {
				this.qfundClassGridListres = gridRes;
				if (this.qfundClassGridListres.length > 0) {
					this.trcFundClasses = JSON.parse(sessionStorage.getItem("TRCFundClasses") ?? "");
				
				this.initialFundClasses = this.qfundClassGridListres.filter((obj : any)=> obj.initialMeasureInd===1 && obj.sfwRuleType!=='SUB');
					if(this.initialFundClasses.length > 0){
						/*total grids in eappreg and trc screen was mismatching, so pushing all fund classes for tax-periods*/
						for (let j = 0; j < this.initialFundClasses.length; j++) {	
							if(!(this.initialFundClasses[j].currentTaxPeriod === true)){	
								this.trcFundClasses.push(this.initialFundClasses[j]);	
						}	
					}
						this.showTaxPeriodGrid = true;
					}
					this.nonInitialFundClasses = this.qfundClassGridListres.filter((obj : any)=> obj.initialMeasureInd===0 && !obj.currentTaxPeriod && obj.sfwRuleType!=='SUB' );
					/*for (let j = 0; j < this.nonInitialFundClasses.length; j++) {
								const indexOfObject = this.trcFundClasses.findIndex(obj => obj.revenue_type === this.nonInitialFundClasses[j]?.revenue_type && this.nonInitialFundClasses[j]?.measure===0 && obj.measure===0)
								if (indexOfObject >= 0) {
         							this.trcFundClasses.splice(indexOfObject,1)
								}
							}*/
					
					for (let j = 0; j < this.nonInitialFundClasses.length; j++) {
						this.trcFundClasses.push(this.nonInitialFundClasses[j]);
					}
					this.qfundClassGridListres = this.initialFundClasses;
					/*Handling to show date from and date to year one year less than tax-period*/
					for (let j = 0; j < this.qfundClassGridListres.length; j++) {	
							
						const str = this.qfundClassGridListres[j].taxPeriod;	
						const lastLetter = str[str.length - 1];	
						this.qfundClassGridListres[j].dateFrom = (this.decrementFromYear(this.qfundClassGridListres[j].dateFrom , lastLetter));	
						this.qfundClassGridListres[j].dateTo = (this.decrementToYear(this.qfundClassGridListres[j].dateTo, lastLetter));	
							
							
							
					}
					this.calculateTotalMeasures();
				} else {
					this.trcFundClasses = JSON.parse(sessionStorage.getItem("TRCFundClasses") ?? "");
					this.showTaxPeriodGrid = false;
				}
				for (let i=0;i<this.qfundClassGridListres.length;i++){
						if(this.qfundClassGridListres[i].revenue_type ==='L188'){
							this.dumm = i;
						}
					}
			});

		} else {
			this.showTaxPeriodGrid = false;
		}
	}
	//INC0754669 - Enhancement - PFA EappReg - Adding GGR
	calculateTotalMeasures():any{
			sessionStorage.setItem("totalMsr", "0");
			for (let j = 0; j < this.qfundClassGridListres.length; j++) {
					const str = this.qfundClassGridListres[j].taxPeriod;
					const lastLetter = str[str.length - 1];
					if (lastLetter === 'A' && this.qfundClassGridListres[j].currentTaxPeriod ){
					const fundclIndex = this.trcFundClasses.findIndex(obj => obj.revenue_type === this.qfundClassGridListres[j].revenue_type && obj.taxPeriod === '')
					this.totalMsr=Number(sessionStorage.getItem("totalMsr"));
					this.totalMsr += Number(this.trcFundClasses[fundclIndex].measure);
					sessionStorage.setItem("totalMsr", this.totalMsr);
					
			}
			}
			sessionStorage.setItem("GGR", this.ggr);
			this.totMeasures=sessionStorage.getItem("totalMsr");
			if(this.ggr!==''){
				if(Number(this.ggr) < this.totMeasures){
					this.errorGgrMeasures();
				}
			}
		}
			  
//INC0754669 - Enhancement - PFA EappReg - Adding GGR
		errorGgrMeasures(): void {
    

      const title = "Confirmation"
	  const body = "The Total Gross Receipts cannot be less than the sum of all Measures(Basis for Tax) entered."
      const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
      modalRef.componentInstance.cModalTitle = title
      modalRef.componentInstance.cModalBody = body
      modalRef.result.then((userResponse) => {
        if (userResponse === "OK") {
          this.router.navigate(['/eappreg_app']);
        }
      });
    }
			
	//INC0754669 - Enhancement - PFA EappReg - Adding GGR
	calculateTotalMeasuress(qfundClassGrid: TRCFundClasses, event: any):any{
			
					const fundclIndex = this.trcFundClasses.findIndex(obj => obj.revenue_type === qfundClassGrid.revenue_type && obj.taxPeriod === '')
					const str = qfundClassGrid.taxPeriod;
					const lastLetter = str[str.length - 1];
					if (fundclIndex >= 0) {
						if (lastLetter === 'A' && qfundClassGrid.currentTaxPeriod ){
							this.totalMsr=Number(sessionStorage.getItem("totalMsr"));
							this.totalMsr -= Number(this.trcFundClasses[fundclIndex].measure);
							this.totalMsr +=Number(event.target.value);
							sessionStorage.setItem("totalMsr", this.totalMsr);
							
				}
				}
				
				this.totMeasures=Number(sessionStorage.getItem("totalMsr"));
			if(this.ggr!==''){
				if((Number(this.ggr) < this.totMeasures) ){
				
					this.fForm.controls.globalGrossReceipts.setErrors({ validateGgrErr: true });
					this.errorGgrMeasures();
  					} 
				}
			else {
    			this.fForm.controls.globalGrossReceipts.setErrors(null);
  				}
		
			}
			
	/*Added function to show date from and date to year one year less than tax-period*/
	decrementToYear(dateString : string, lastLetter :string) : any{	
		const parts = dateString.split("-");	
		if(lastLetter === 'A'){	
			this.year =Number(parts[0])-1	
		}	
		else{	
			this.year =Number(parts[0]);	
		}	
		const month = Number(parts[1]);	
		const day= Number(parts[2]);	
		return new Date(this.year, month-1, day);	
	}	
		
	decrementFromYear(dateString : string, lastLetter :string) : any{	
		const parts = dateString.split("-");	
		if(lastLetter === 'A'){	
			this.year =Number(parts[0])-1	
		}	
		else{	
			this.year =Number(parts[0]);	
		}	
		const month = Number(parts[1]);	
		const day= Number(parts[2]);	
		return new Date(this.year, month-1, day);	
	}

	addMeasure(qfundClassGrid: TRCFundClasses, event: any): void {
		if(!qfundClassGrid.currentTaxPeriod){
		const fundclIndex = this.trcFundClasses.findIndex(obj => obj.revenue_type === qfundClassGrid.revenue_type && obj.taxPeriod === qfundClassGrid.taxPeriod)
		if (fundclIndex >= 0) {
			this.trcFundClasses[fundclIndex].measure = event.target.value
		} else {
			qfundClassGrid.measure = event.target.value;
			this.trcFundClasses.push(qfundClassGrid);
		}
		}
		//for Current tax period instead of adding a new row updating in existing row.
		else{
			const fundclIndex =this.trcFundClasses.findIndex(obj =>obj.revenue_type === qfundClassGrid.revenue_type && obj.taxPeriod==='')
			if (fundclIndex >= 0) {
			this.trcFundClasses[fundclIndex].measure = event.target.value
		} 
		}
	}
	
	
	addPayReceipt(qfundClassGrid: TRCFundClasses, event: any): void {
		const fundclIndex = this.trcFundClasses.findIndex(obj => obj.revenue_type === qfundClassGrid.revenue_type && obj.taxPeriod === qfundClassGrid.taxPeriod)
		if (fundclIndex >= 0) {
			this.trcFundClasses[fundclIndex].payReceipt = event.target.value
		} else {
			qfundClassGrid.payReceipt = event.target.value;
			this.trcFundClasses.push(qfundClassGrid);
		}
	}
	isNumber(inputElObj: any): boolean {
		const isValid = ( (inputElObj.length > 0) && (inputElObj.search(new RegExp("\\D")) === -1) ) ? true : false;
		return isValid;
	}
	validateFEIN(event :any) : void {
		if(event.target.value === 'COR'){
			const fein = sessionStorage.getItem('FEIN');
			if(fein==='' || fein===null){
				const title = "Validation"
					const body = "Please make sure FEIN is entered when we select Corporation as Business Type."
					const modalRef = this.modalService.open(CustomAlertModalComponent)
					modalRef.componentInstance.cModalTitle = title
					modalRef.componentInstance.cModalBody = body
					return;
			}
		}
	}
	dateValid(): any{
		const currDate=this.fForm.get("busact_start_dt").value
		
		const currDateArrayy = currDate.split(" ");
		const currentDatee = currDateArrayy[0].split("/");
		
		if(Number(currentDatee[2]) < this.yy){
			
				    this.issDisable=true
					this.fForm.controls['busact_start_dt'].errors=true;
			
			
		}
		else if(Number(currentDatee[2]) <= this.yy){
			if(Number(currentDatee[0]) < this.mm && Number(currentDatee[0]) >=1 ){
				if(Number(currentDatee[1] < this.dd )){
					this.issDisable=true
					this.fForm.controls['busact_start_dt'].errors=true;
				}
			}
			else if(Number(currentDatee[0]) < this.mm ){
				    this.issDisable=true
					this.fForm.controls['busact_start_dt'].errors=true;
			}
			else if(Number(currentDatee[0]) > this.mm && Number(currentDatee[0]) < this.mmm ){
				this.issDisable=false
			}
			else {
				this.issDisable=false
			}
			
		}
		else if(Number(currentDatee[2]) > this.yym){
			this.issDisable=true
	        this.fForm.controls['busact_start_dt'].errors=true;
		}
		
		 
		else{
			this.issDisable=false
			
		}
	}
}